module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (188).5199c77c.jpg";